export const SUPPORT_EMAIL = 'Support_fleet@ravity.io';

export const SUPPORT_MAILTO_LINK = `mailto:${SUPPORT_EMAIL}`;

